import { z } from "zod";

export const learningVideoSchema = z
  .object({
    provider: z.literal("vimeo"),
    videoId: z.string().regex(/^\d+$/),
    startSeconds: z.number().int().min(0).optional(),
    endSeconds: z.number().int().positive().optional(),
  })
  .strict()
  .refine((video) => (video.startSeconds === undefined) === (video.endSeconds === undefined), {
    message: "A video clip requires both start and end times.",
    path: ["endSeconds"],
  })
  .refine((video) => video.startSeconds === undefined || video.endSeconds! > video.startSeconds, {
    message: "A video clip must end after it starts.",
    path: ["endSeconds"],
  });
